module.exports = __webpack_public_path__ + "static/media/House.fa896591.svg";